import React from 'react';
import './styles/gallery/nav.scss';
import './styles/welcome/globals.scss';
import './styles/welcome/section1.scss';
import './styles/welcome/bottom-section.scss';
// import './styles/.scss';
import {
  BrowserRouter as Router, Route, Switch, NavLink,
} from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import Welcome from './screens/welcome';
import ScrollToTop from './scrolltotop';

library.add(far);

const FallBack = (props) => {
  return (
    <div id="fallbackcontainer">
      <div id="fallbacktext">URL Not Found</div>
      <NavLink id="fallbackbutton" to="/">Go Back Home</NavLink>
    </div>
  );
};

const App = (props) => {
  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route exact path="/" component={Welcome} />
          <Route component={FallBack} />
        </Switch>
      </ScrollToTop>
    </Router>
  );
};

export default App;
